import queryString from "query-string";
import { GET_BUSSINESS_UNIT,GET_BUSSINESS_UNIT_EMPLOYEE } from "@/api/master-data/business-unit/business-unit";

const state = {
    bussiness: [],
    bussinessEmployee: [],
};
const mutations = {
    setBussiness: (states, payload) => {
        states.bussiness = payload;
    },
    setBussinessEmployee: (states, payload) => {
        states.bussinessEmployee = payload;
    },  

};
const actions = {
    getBusinessUnit: async ({ commit }, args) => {
        const params = queryString.stringify(args);

        try {
            const resp = await GET_BUSSINESS_UNIT(params);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setBussiness", resp);
                return resp;
            }
        } catch (err) {
            const resp = err.response;
            // console.log(resp)
            if (resp.data.httpCode === 404) {
                commit("setBussiness", []);
            }
            throw err;
        }
    },
    getBusinessUnitEmployee: async ({ commit }, args) => {
        const params = queryString.stringify(args);

        try {
            const resp = await GET_BUSSINESS_UNIT_EMPLOYEE(params);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setBussinessEmployee", resp);
                return resp;
            }
        } catch (err) {
            const resp = err.response;
            // console.log(resp)
            if (resp.data.httpCode === 404) {
                commit("setBussinessEmployee", []);
            }
            throw err;
        }
    },
};

const getters = {
    bussinessUnit: (states) => states.trainingProviders,
    bussinessUnitEmployee: (states) => states.bussinessEmployee,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
